import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { BroadcastingElementBasic } from './broadcasting-element-basic.model';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';

export class BroadcastingInfo {

    active: boolean;
    broadcastingCalendars: Schedule[];
    broadcastingElements: BroadcastingElementBasic[];
    broadcastingInternalId: string;
    broadcastingName: string;
    centerBound: CenterLite[];
    devicesBound: DeviceBasic[];
    showApp: boolean;

    constructor(active?: boolean,
        broadcastingCalendars?: Schedule[],
        broadcastingElements?: BroadcastingElementBasic[],
        broadcastingInternalId?: string,
        broadcastingName?: string,
        centerBound?: CenterLite[],
        devicesBound?:  DeviceBasic[],
        showApp?: boolean) {
        this.active = active;
        this.broadcastingCalendars = broadcastingCalendars;
        this.broadcastingElements = broadcastingElements;
        this.broadcastingInternalId = broadcastingInternalId;
        this.broadcastingName = broadcastingName;
        this.centerBound = centerBound;
        this.devicesBound = devicesBound;
        this.showApp = showApp;
    }

    public get Active() {
        return this.active;
    }
    public get BroadcastingCalendars() {
        return this.broadcastingCalendars;
    }
    public get BroadcastingElements() {
        return this.broadcastingElements;
    }
    public get BroadcastingInternalId() {
        return this.broadcastingInternalId;
    }
    public get BroadcastingName() {
        return this.broadcastingName;
    }
    public get CenterBound() {
        return this.centerBound;
    }
    public get DevicesBound() {
        return this.devicesBound;
    }
    public get ShowApp() {
        return this.showApp;
    }
    public set Active(active) {
        this.active = active;
    }
    public set BroadcastingCalendars(broadcastingCalendars) {
        this.broadcastingCalendars = broadcastingCalendars;
    }
    public set BroadcastingElements(broadcastingElements) {
        this.broadcastingElements = broadcastingElements;
    }
    public set BroadcastingInternalId(broadcastingInternalId) {
        this.broadcastingInternalId = broadcastingInternalId;
    }
    public set BroadcastingName(broadcastingName) {
        this.broadcastingName = broadcastingName;
    }
    public set CenterBound(centerBound) {
        this.centerBound = centerBound;
    }
    public set DevicesBound(devicesBound) {
        this.devicesBound = devicesBound;
    }
    public set ShowApp(showApp) {
        this.showApp = showApp;
    }
}
